import {
  AfterContentInit,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { CHANNEL } from 'src/app/shared/constants/channel.constants';
import {
  ProductsBiocatchEnum,
  StepBiocatchEnum,
} from 'src/app/shared/enums/biocatchContext.enum';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { IdentificationService } from 'src/app/shared/services/identification/identification.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';
import {
  SEGMENTS_CONST,
  RISK_LEVELS,
} from '../../../shared/constants/rate.constants';
import { BUSINESS_CONST } from '../../../shared/constants/business.constants';
import { OpEnum } from '../../../shared/enums/op.enum';
import {
  CardTypeModel,
  DetailAccountModel,
  ProductCard,
} from '../../../shared/models/abre-cuentas.model';
import { AgreementsModel } from '../../../shared/models/agreements.model';
import { ExternalResponse } from '../../../shared/models/channel-communicator/external-response.model';
import {
  CheckboxModel,
  OptionRadioModel,
} from '../../../shared/models/common.model';
import { DocumentModel } from '../../../shared/models/document.model';
import { IProductsModel } from '../../../shared/models/products.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { ChannelCommunicatorService } from '../../../shared/services/communicator/channel-communicator/channel-communicator.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { BioCatchService } from '../../../shared/services/external/biocatch/biocatch.service';
import { CryptoVaultService } from '../../../shared/services/external/crypto-vault/crypto-vault.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { ProductLoaderService } from '../../../shared/services/product-loader/product-loader.service';
import { SignOnService } from '../../../shared/services/sign-on/sign-on.service';
import { ValidationHelperService } from 'src/app/shared/services/helpers/validation-helper.service';
import { AdjustEvent } from 'src/app/shared/services/external/adjust/adjust.service';
import {
  callbackAdjustCA,
  callbackAdjustContratarTC,
} from 'src/app/shared/constants/adjust-callback';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
import { FormatNumberService } from 'src/app/shared/utils/format-number.service';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { OFFERS_STATUS_CONST } from 'src/app/shared/constants/offers-status.constants';
import { PlatformCommunicatorAuthService } from 'src/app/shared/services/communicator/platform-communicator/platform-communicator.auth.service';
import { StringFormatPipe } from 'src/app/shared/pipe/string.format.pipe';
import { PlatformEndpointService } from 'src/app/shared/services/communicator/endpoint/endpoint.service';
import { DaliService, IPageLoadModel } from '@dali/tagger-ng8';
import {
  EVENT as EVENT_FA_TC,
  PAGEVIEW as PAGEVIEW_FA,
  CHANNEL as CHANNEL_FA,
  COUNTRY as COUNTRY_FA,
  BUSINNESS as BUSINNESS_FA,
  ENVIRONMENT as ENVIRONMENT_FA,
  FAMILY as FAMILY_FA,
  SUBFAMILY as SUBFAMILY_FA,
  PRODUCT as PRODUCT_FA } from 'src/app/shared/constants/dali-fa-tc.constants';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';

export enum AccountCreationStatus {
  NOT_REQUESTED = 'notRequested',
  REQUESTED = 'requested',
  REQUEST_FAILED = 'requestFailed',
  PEDNING = 'pending',
  TIME_OUT_STATUS = 'timeOutStatus',
  CREATED = 'created',
}

@Component({
  selector: 'app-detail-account-creation',
  templateUrl: './detail-account-creation.component.html',
  styleUrls: ['./detail-account-creation.component.scss'],
})
export class DetailAccountCreationComponent
  implements OnInit, AfterContentInit {
  subTitle;
  copiesDocToSend: any;
  documentation_to_send: any;
  selectedOccupation;
  requestLoan;
  showModal = false;
  showModalTerm = false;
  isBtnDisabled = true;
  checkboxTerms: CheckboxModel;
  benefitsList: string[];
  transactionkit: any = [];
  transactionkitMono: any = [];
  detailAccountInfo: DetailAccountModel;
  transaction: any = [];
  acctStatus: AccountCreationStatus;
  acctProcessId: string;
  documentInfo: DocumentModel;
  infoInferredIncomes: any;
  showSecondaryButton = true;
  scanResponse: ExternalResponse;
  productsDetail: IProductsModel;
  selectedProduct: IProductsModel;
  selectedPayDayProduct: OptionRadioModel;
  agreementSelected: AgreementsModel;
  terms = { text: '', title: '', terms_id: '' };
  termsAndConditions: any;
  buttonLabelsModal = {};
  buttonLabelsModalTerms = {};
  copiesProperty = {};
  showFotter = false;
  grayZone = false;
  check = false;
  client: boolean;
  amountPco: string;
  cardType: CardTypeModel;
  viewOptionMultiProduct: boolean;
  haveloan: boolean;
  productsMulti: any;
  productsSelectedMulti: any;
  showMor = true;
  noShare = false;
  arrowIconDown = 'seta_baixo';
  arrowIconUp = 'seta_cima';
  productSele: any[] = [];
  dataProducts: any[] = [];
  select_products: any[] = [];
  granted_product_multi: any[] = [];
  active: string;
  isLoan = false;
  labelBTN;
  continueRelated: boolean;
  iscardDuality: boolean;
  multi: any[];
  revolvingBenefits: any;
  no_manegement_fee: any;
  lifeMiles: any = false;
  segment: any;
  accountNumber: any;
  accountNumberRevolving: any;
  postLogin: boolean;
  product_type: string;
  firmlyApproved: boolean;
  pageTagEvent: any;
  disbursment: any;
  showCharacteristics: any;
  isRevolingCreateSavings: boolean;
  isCreateSavingsLoan: boolean;
  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private signOnService: SignOnService,
    private authService: PlatformCommunicatorAuthService,
    private bioCatchService: BioCatchService,
    private navigationService: NavigationService,
    public abreCuentasService: AbreCuentasService,
    private parametersService: ParametersService,
    private productLoaderService: ProductLoaderService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private bitacoraService: BitacoraService,
    private cryptoVaultService: CryptoVaultService,
    private cdr: ChangeDetectorRef,
    private captureService: CaptureService,
    private requestService: RequestService,
    private helperService: HelpersService,
    private numberHelper: FormatNumberService,
    private identificationService: IdentificationService,
    private parameterService: ParametersService,
    private validationHelperService: ValidationHelperService,
    private adjustEvent: AdjustEvent,
    private firmlyApprovedServices: FirmlyApprovedService,
    public loader: LoaderService,
    private stringFormat: StringFormatPipe,
    private endpointService: PlatformEndpointService,
    private taggingServices: TaggingService,
    private daliService: DaliService,
  ) {
    this.headerService.show(true, true, true);
    this.buttonLabelsModal = {
      primary: copyService.copies.detail_account_creation_modal_button,
    };
    this.buttonLabelsModalTerms = {
      primary: copyService.copies.detail_account_creation_modal_button_terms,
    };
  }

  ngOnInit() {
    if (this.abreCuentasService.getproductSelected().product_type !== 'livingPlace') {
      this.restrictiveList();
    }
    if (this.taggingServices.isFirmlyAprovedMono()) {
      this.sendDetailCreationPageLoad();
    }
    console.log(
      '---------------------- Detail-account-creation ------------------',
    );
    /**
     * firmlyApproved es un Boolean que indica:
     * True - Viene por flujo de Aprobados en Firme
     * False - viene por flujo Onboarding normal
     */
    const incomes = this.abreCuentasService.getFinancialInfo();
    this.isRevolingCreateSavings = false;
    this.isCreateSavingsLoan = false;
    this.showCharacteristics = incomes.incomes <= 7999000 ? false : true;
    this.firmlyApproved =
      !this.firmlyApprovedServices.isEmpty() &&
      this.firmlyApprovedServices.getOfferType_Channel() === 'En_firme';
    this.productsSelectedMulti = this.abreCuentasService.getProductsSelects();
    this.documentation_to_send = this.copyService.copies.documentation_to_send;
    this.selectedOccupation =
      this.abreCuentasService.getOccupationSelected().name;
    this.requestLoan =
      this.abreCuentasService.getRequestLoanSelected().elementId;
    this.iscardDuality = this.navigationService.cardDuality;
    const postLogin = this.abreCuentasService.getPostlogin();
    let products = postLogin
      ? this.firmlyApproved
        ? this.parameterService.getSetting(OpEnum.APROBADOS_FIRME_CE)
        : this.parameterService.getSetting(OpEnum.ABRE_CUENTAS_PRODUCTS_CE)
      : this.parameterService.getSetting(OpEnum.ABRE_CUENTAS_PRODUCTS);
    this.multi = products;
    this.viewOptionMultiProduct =
      this.abreCuentasService.viewOptionMultiProduct;
    this.haveloan = this.abreCuentasService.haveLoan;
    this.granted_product_multi = !this.firmlyApproved
      ? this.abreCuentasService.getPcoModel().granted_product_multi
      : this.firmlyApprovedServices.getDetailProductsMulti();
    this.copiesProperty = {
      termsLabel: 'detail_account_creation_link_label',
      nextButtonLabel: 'detail_account_creation_button',
      ContButtonLabel: 'detail_account_creation_button_Cont',
      mainLabel: 'detail_account_creation_title_saving',
      mainLabel2: 'detail_bonding',
      transactionsLabel: 'detail_account_creation_label_transaction',
    };
    const product = this.abreCuentasService.getproductSelected()
      .product_code as ProductsBiocatchEnum;
    this.grayZone = this.abreCuentasService.isGrayZone();
    const isEvidente = this.bioCatchService.isEvidenteCase();
    this.bioCatchService.changeContext(
      StepBiocatchEnum.vinculacion,
      product,
      !postLogin,
      isEvidente,
    );
    this.termsAndConditions =
      this.abreCuentasService.getPayDayProductSelected();
    this.acctStatus = AccountCreationStatus.NOT_REQUESTED;
    if (this.viewOptionMultiProduct) {
      this.checkboxTerms = {
        id: '1',
        label: this.copyService.copies.detail_account_creation_term,
        checked: false,
        value: '1',
      };
    } else if (!this.viewOptionMultiProduct) {
      this.checkboxTerms = {
        id: '1',
        label: this.copyService.copies.detail_account_creation_terms,
        checked: false,
        value: '1',
      };
    }
    const { selectedProduct } =
      this.abreCuentasService.getPayDayProductSelected();
    this.selectedPayDayProduct = selectedProduct;
    this.transaction = JSON.parse(
      JSON.stringify(this.parametersService.getSetting(OpEnum.TRANSACTION_KIT)),
    );
    this.revolvingBenefits = this.parametersService.getSetting(
      OpEnum.REVOLVING_BENEFITS,
    );
    if (!this.parametersService.getSetting(OpEnum.DATA_TERMS_CONDITIONS)) {
      return;
    }
    this.documentInfo = this.abreCuentasService.getDocumentInfo();
    this.selectedProduct = this.abreCuentasService.getproductSelected();
    if (
      this.selectedProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS
    ) {
      const event = {
        eventToken: '3duuk6',
        callbackParams: callbackAdjustCA,
      };
      this.adjustEvent.adjustTrackEvent(event);
    }
    setTimeout(() => {
      this.showFotter = true;
    }, 100);
    /* this.showBackButton(); */
    this.accountDetail();
    this.filterSettingsMulti();
  }

  ngAfterContentInit(): void {
    this.cdr.detectChanges();
  }

  /**
   * Summary capture account details
   */
  accountDetail() {
    if (this.iscardDuality) {
      this.multi = this.multi.filter(
        (product: any) => product.product_type === 'multi',
      );
      this.selectedProduct = this.multi[0];
      this.viewOptionMultiProduct = true;
    }
    this.infoInferredIncomes = this.abreCuentasService.getinfoInferredIncomes();
    this.client = this.abreCuentasService.getProspectResponse().client;

    if (
      this.infoInferredIncomes.account_type === '232' &&
      this.abreCuentasService.getSegmentID() === '335'
    ) {
      this.copiesProperty = {
        termsLabel: 'detail_account_creation_link_label',
        nextButtonLabel: 'detail_account_creation_button',
        mainLabel: 'detail_account_creation_title_saving_basic',
        mainLabel2: 'detail_bonding',
        transactionsLabel: 'detail_account_creation_label_transaction',
      };
    }

    if (
      this.client &&
      (this.abreCuentasService.getSegmentID() === '335' ||
        this.abreCuentasService.getSegmentID() === '315')
    ) {
      this.infoInferredIncomes.segment_id =
        this.abreCuentasService.getCustomerData().basic.sub_segment_id;
    }
    // Cuenta de ahorros tradicional
    if (
      this.selectedProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS
    ) {
      const accountsTermsText = this.parametersService
        .getSetting(OpEnum.DATA_TERMS_CONDITIONS)
        .filter(accountTerm => this.getValueObject(accountTerm, 'id') === 1);
      this.terms = {
        text: accountsTermsText[0].description,
        title: accountsTermsText[0].code,
        terms_id: this.getValueObject(accountsTermsText[0], 'id'),
      };
    }

    // Cuenta de nómina
    if (
      this.selectedProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL
    ) {
      const accountsTermsText = this.parametersService
        .getSetting(OpEnum.DATA_TERMS_CONDITIONS)
        .filter(accountTerm => this.getValueObject(accountTerm, 'id') === 1);

      this.terms = {
        text: accountsTermsText[0].description,
        title: accountsTermsText[0].code,
        terms_id: this.getValueObject(accountsTermsText[0], 'id'),
      };
      if (this.viewOptionMultiProduct) {
        this.checkboxTerms = {
          id: this.terms.terms_id,
          label: this.copyService.copies.detail_account_creation_term,
          checked: false,
          value: this.terms.terms_id,
        };
      } else if (!this.viewOptionMultiProduct) {
        this.checkboxTerms = {
          id: this.terms.terms_id,
          label: this.copyService.copies.detail_account_creation_terms,
          checked: false,
          value: this.terms.terms_id,
        };
      }

      this.copiesProperty = {
        termsLabel: 'detail_account_creation_link_label',
        nextButtonLabel: 'detail_account_creation_button_tc',
        mainLabel: 'detail_account_creation_title_payroll',
        mainLabel2: 'detail_bonding',
        transactionsLabel: 'detail_account_creation_label_benefit',
      };
      this.transactionkit = this.transaction.filter(
        transaction =>
          transaction.account_type === this.infoInferredIncomes.account_type &&
          transaction.segmentation_id ===
          this.abreCuentasService.getSegmentID(),
      );
      this.transactionkit = this.transactionkit[0];
      this.agreementSelected = this.abreCuentasService.getAgreementSelected();
      if (this.agreementSelected.transaction_type === 'false') {
        this.benefitsList = this.abreCuentasService.getBenefitsList();
        this.navigationService.getCurrentStep().tag_name = this.client
          ? 'pv131'
          : 'pv217';
      } else {
        this.copiesProperty = {
          termsLabel: 'detail_account_creation_link_label',
          nextButtonLabel: 'detail_account_creation_button_tc',
          mainLabel: 'detail_account_creation_title_payroll',
          mainLabel2: 'detail_bonding',
          transactionsLabel: 'detail_account_creation_label_transaction',
        };
      }
      return;
    }

    // TC
    if (this.selectedProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC) {
      // this.copiesProperty.mainLabel
      this.copiesProperty = {
        termsLabel: 'detail_account_creation_link_label_tc',
        nextButtonLabel: 'detail_account_creation_button_tc',
        mainLabel: 'detail_account_creation_title_tc_success',
        mainLabel2: 'detail_bonding',
        transactionsLabel: 'detail_account_creation_label_transaction_tc',
      };
      if (!this.grayZone) {
        const event = {
          eventToken: 'bx7giv',
          callbackParams: callbackAdjustContratarTC,
        };
        this.adjustEvent.adjustTrackEvent(event);
      }
      const creditCardTermsText = this.parametersService
        .getSetting(OpEnum.DATA_TERMS_CONDITIONS)
        .filter(accountTerm => this.getValueObject(accountTerm, 'id') === 2);
      this.terms = {
        text: creditCardTermsText[0].description,
        title: creditCardTermsText[0].code,
        terms_id: this.getValueObject(creditCardTermsText[0], 'id'),
      };
      this.checkboxTerms = {
        id: this.terms.terms_id,
        label: this.copyService.copies.detail_account_creation_terms_tc,
        checked: false,
        value: this.terms.terms_id,
      };
      const card = this.abreCuentasService.getCardTypeModel();

      this.cardType = {
        ...card,
        periodo_exoneracion: card.periodo_exoneracion
          ? card.periodo_exoneracion.toLowerCase().replace(' ', ' primeros ')
          : '',
        couta_manejo: card.couta_manejo
          ? card.couta_manejo.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
          : '',
        meta_facturacion_mensual: card.meta_facturacion_mensual
          ? card.meta_facturacion_mensual.replace(
            /(\d)(?=(\d{3})+(?!\d))/g,
            '$1.',
          )
          : '',
      };
      this.grayZone = this.abreCuentasService.isGrayZone();
      this.segment = this.abreCuentasService.getSegmentID();
      this.transactionkit = this.transaction.filter(
        transaction =>
          transaction.account_type === '219' &&
          transaction.segmentation_id === this.segment,
      );
      this.transactionkit = this.transactionkit[0];
      if (
        this.grayZone === true &&
        this.abreCuentasService.getPostlogin() === true
      ) {
        this.navigationService.getCurrentStep().tag_name = 'pv453';
      } else if (
        this.grayZone === true &&
        this.abreCuentasService.getPostlogin() === false
      ) {
        this.navigationService.pageLoadTag(false, ['pv418', '', '', '']);
      }
      this.transactionkit.detail[0].value =
        this.cardType.tipo_tarjeta.replace('Ã¡', '\u00E1') +
        ' ' +
        this.abreCuentasService.getPayDayProductSelected().selectedProduct
          .label;
      // this.transactionkit.detail[2].detail = this.cardType.periodo_exoneracion;
      if (
        this.termsAndConditions &&
        this.termsAndConditions.hasOwnProperty('selectedPayDay') &&
        this.termsAndConditions.selectedPayDay.hasOwnProperty('label')
      ) {
        this.transactionkit.detail[3].value =
          this.termsAndConditions.selectedPayDay.label;
      }

      if (
        card.brand === 'VISA LIFE MILES' &&
        (card.tipo_tarjeta === 'Gold' || card.tipo_tarjeta === 'Signature')
      ) {
        this.lifeMiles = true;
        this.transactionkitMono = this.copyService.getCopy(
          'detail_account_life_miles',
        );
      } else if (
        card.tipo_tarjeta === 'Gold' ||
        card.tipo_tarjeta === 'Platinum' ||
        card.tipo_tarjeta === 'Infinite' ||
        card.tipo_tarjeta === 'Clasica' ||
        card.tipo_tarjeta === 'Black'
      ) {
        let product;
        if (this.firmlyApproved) {
          product = this.firmlyApprovedServices
            .getDetailProductsMulti(BUSINESS_CONST.PRODUCT_TYPE_TC)
            .find(element => {
              return (
                String(element.brand).toLowerCase() ===
                String(card.brand).toLowerCase()
              );
            });
        } else {
          product = this.abreCuentasService.getPcoModel().granted_product;
        }
        this.lifeMiles =
          product.limit_amount.amount < 4000000 &&
            card.tipo_tarjeta === 'Clasica'
            ? true
            : false;
        this.transactionkitMono = this.copyService.getCopy(
          'detail_account_no_life_miles',
        );
      }
      console.warn('Lifemiles: ', this.lifeMiles);

      this.transactionkit.share[0].description =
        this.copyService.getParametrizedCopy(
          'detail_account_use_and_dont_pay_text',
          [this.cardType.meta_facturacion_mensual, this.cardType.couta_manejo],
        );

      if (this.grayZone) {
        this.copiesProperty = {
          termsLabel: 'detail_account_creation_link_label_tc',
          nextButtonLabel: 'detail_account_creation_button_tc',
          mainLabel: 'detail_account_creation_title_tc',
          mainLabel2: 'detail_bonding',
          transactionsLabel: 'detail_account_creation_label_transaction_tc',
        };
        if (this.transactionkit.detail[0].detail !== 'Número de solicitud') {
          this.transactionkit.detail[0].value =
            this.abreCuentasService.getPayDayProductSelected().selectedProduct.label;
          this.transactionkit.detail[0].detail = this.copyService.getCopy(
            'detail_account_creation_franchise',
          );
        }

        this.copiesProperty['termsLabel'] =
          'detail_account_creation_link_label_tc';
        const transactionNumber = {
          detail: 'Número de solicitud',
          value: this.abreCuentasService.getSolicitationId(),
        };
        const evento = {
          eventToken: 'k4b9yo',
          callbackParams: callbackAdjustContratarTC,
        };
        this.adjustEvent.adjustTrackEvent(evento);
        if (this.transactionkit.detail[0].detail !== 'Número de solicitud') {
          this.transactionkit.detail.unshift(transactionNumber);
        } else {
          this.transactionkit.detail[0] = transactionNumber;
        }

        const detailTK = this.transactionkit.detail.filter(
          transaction =>
            transaction.detail !== 'Tarjeta virtual' &&
            transaction.detail !== '2 primeros meses' &&
            transaction.detail !== '',
        );
        this.transactionkit.detail = detailTK;
      } else {
        if (!this.viewOptionMultiProduct) {
          let products_firmlyApproved;
          if (this.firmlyApproved) {
            products_firmlyApproved = this.firmlyApprovedServices
              .getDetailProductsMulti(BUSINESS_CONST.PRODUCT_TYPE_TC)
              .find(element => {
                return (
                  String(element.brand).toLowerCase() ===
                  String(card.brand).toLowerCase()
                );
              });
          }
          this.amountPco = this.firmlyApproved
            ? products_firmlyApproved.limit_amount.amount
              .toString()
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
            : this.abreCuentasService
              .getPcoModel()
              .granted_product.limit_amount.amount.toString()
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
        }
        this.agreementSelected = this.abreCuentasService.getAgreementSelected();
      }
      if (
        this.transactionkit.id === 3 &&
        this.abreCuentasService.getPostlogin() === true &&
        !this.grayZone === true
      ) {
        this.navigationService.getCurrentStep().tag_name = 'pv452';
      } else if (
        this.transactionkit.id === 3 &&
        !this.abreCuentasService.getPostlogin() === true &&
        !this.grayZone === true
      ) {
        this.navigationService.pageLoadTag(false, ['pv54', '', '', '']);
      }
      return;
    }
    this.setSubTitle();
    this.setBTNNex();
    if (this.selectedProduct.product_type === BUSINESS_CONST.MULTI) {
      const accountsTermsText = this.parametersService
        .getSetting(OpEnum.DATA_TERMS_CONDITIONS)
        .filter(accountTerm => this.getValueObject(accountTerm, 'id') === 3);
      this.terms = {
        text: accountsTermsText[0].description,
        title: accountsTermsText[0].code,
        terms_id: this.getValueObject(accountsTermsText[0], 'id'),
      };
      let productList = this.abreCuentasService.getProductsSelects();
      productList.forEach(element => {
        if (element.product_type == BUSINESS_CONST.PRODUCT_TYPE_FREE) {
          this.freeInvestmentDetail();
        }
        if (element.product_type == BUSINESS_CONST.PRODUCT_TYPE_TC) {
          this.creditCardDetail();
        }
        if (element.product_type == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING) {
          this.revolvingDetail();
        }
        if (element.product_type == BUSINESS_CONST.PRODUCT_TYPE_LOAN) {
          this.loanDetail();
        }
      });
      if (productList.find(find => find.product_type == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING)) {
        this.savingAccountDetailRevolving();
      }
      if (productList.find(find => find.product_type == BUSINESS_CONST.PRODUCT_TYPE_FREE)) {
        this.savingAccountDetail();
      }
      if (this.client && this.abreCuentasService.getcreateProductSelected() && !this.abreCuentasService.haveLoan) {
        const accounts = this.abreCuentasService.getcreateProductSelected();
        this.accountNumber = `${this.validationHelperService.maskPhone(
          accounts.account_id,
        )}`;
      }
      return;
    }
    this.transactionkit = this.transaction.filter(
      transaction =>
        transaction.account_type === this.infoInferredIncomes.account_type &&
        transaction.segmentation_id === this.abreCuentasService.getSegmentID(),
    );
    this.transactionkit = this.transactionkit[0];
    if (this.getValueObject(this.transactionkit, 'id') === 3) {
      this.navigationService.getCurrentStep().tag_name =
        this.abreCuentasService.getProspectResponse().client ? 'pv95' : 'pv210';
    } else if (this.getValueObject(this.transactionkit, 'id') === 2) {
      this.navigationService.pageLoadTag(false, ['', '', 'pv92', '']);
    } else if (this.getValueObject(this.transactionkit, 'id') === 1) {
      this.navigationService.pageLoadTag(false, ['', '', 'pv89', '']);
    }
  }

  filterSettingsMulti() {
    this.select_products = this.abreCuentasService.getProductsSelects();
    this.productsMulti =
      this.abreCuentasService.getPcoModel().granted_product_multi;
    // this.productsMulti.forEach(item => {
    //   this.productSele.push(item.product_type);
    // });

    const products = this.firmlyApproved
      ? this.firmlyApprovedServices.getDetailProductsMulti(
        BUSINESS_CONST.PRODUCT_TYPE_TC,
      )
      : this.productsMulti.filter(
        fil => fil.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC,
      );
    const quotaFranchise = this.parameterService.getSetting(
      OpEnum.COST_QUOTA_TC_FRANCHISE,
    );
    for (let row of this.dataProducts) {
      if (row.product_type !== BUSINESS_CONST.PRODUCT_TYPE_SAVINGS) {
        if (
          this.select_products.filter(
            fil => fil.product_type == row.product_type,
          )[0].name != undefined
        ) {
          row.es = this.select_products.filter(
            fil => fil.product_type == row.product_type,
          )[0].name;
        }
        if (
          row.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC &&
          this.iscardDuality
        ) {
          row.cardTypes.forEach(target => {
            products.forEach(product => {
              if (target.brand === product.brand) {
                let rate = quotaFranchise.find(
                  filter =>
                    filter.montoMin <= product.limit_amount.amount &&
                    filter.montoMax >= product.limit_amount.amount,
                );
                target.meta_facturacion_mensual = rate.quota
                  .toString()
                  .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
                target.granted_product = product;
                target.granted_product.limit_amount.amount =
                  target.granted_product.limit_amount.amount
                    .toString()
                    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
              }
            });
          });
        } else {
          row.granted_product = this.productsMulti.find(
            fil => fil.product_type == row.product_type,
          );
          // row.granted_product = products;
          if (
            this.abreCuentasService.isGrayZone() &&
            row.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE
          ) {
            const creditParams =
              this.abreCuentasService.getAbreCuentasModel().creditParms;
            row.granted_product.limit_amount.amount =
              creditParams.maxAmountValue;
          }
          row.granted_product.limit_amount.amount =
            row.granted_product.limit_amount.amount
              .toString()
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
        }
      }
    }
  }

  /**
   * Summary Show Modal
   */
  toggleModal() {
    this.navigationService.pageLoadTag(false, ['', 'pv133', 'pv90', '']);
    if (this.showSecondaryButton) {
      this.showModal = !this.showModal;
    }
    this.showSecondaryButton = true;
  }
  /**
   * Summary Show Modal Terms
   */
  modalActionTerms(event) {
    if (event.type === 'primary') {
      this.showModalTerm = !this.showModalTerm;
    }
  }
  toggleModalTerms() {
    this.showModalTerm = !this.showModalTerm;
  }

  /**
   * Acción del modal
   *
   * *Modal action*
   *
   * @param event
   * @type {function}
   */
  modalAction(event) {
    if (event.type === 'primary') {
      this.downloadPdf();
    }
  }

  /**
   * Method to download pdf
   */
  downloadPdf() {
    this.channelCommunicatorService
      .getImpl()
      .openPdf(
        this.parametersService.getSetting(OpEnum.DATA_TERMS_CONDITIONS)[0]
          .pdfUrl,
      );
  }

  /**
   * Summary Event to change checkbox and set Prop
   * @param event
   */
  checkboxChange(event: any): void {
    this.checkboxTerms.checked = event.checked;
    this.abreCuentasService.setFiProperty('checkboxTerms', this.checkboxTerms);
    this.enableNextButton();
  }

  /**
   * Summary Enable the Button
   */
  enableNextButton() {
    this.isBtnDisabled =
      !this.abreCuentasService.getFiProperty('checkboxTerms').checked;
  }

  /**
   * summary shipment request open account
   */
  async next() {
    if (this.taggingServices.isFirmlyAprovedMono()) {
      this.sendContinueButtonEvent();
    }
    let gray_zone = '';
    if (this.abreCuentasService.isGrayZone()) {
      gray_zone = '_zg';
    }
    const bitacoraEvent =
      this.selectedProduct.product_type ===
        BUSINESS_CONST.PRODUCT_TYPE_SAVINGS ||
        this.selectedProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL
        ? 'product_terms'
        : 'product_accepted';
    this.bitacoraService.saveDataInBitacora(bitacoraEvent);
    let bitacoraEventPre = this.firmlyApproved ? 'offer_approvedf_multi' : 'Product_accepted';
    this.dataProducts.forEach(product => {
      if (this.firmlyApproved) {
        const productCode = {};
        productCode[BUSINESS_CONST.PRODUCT_TYPE_FREE] = BUSINESS_CONST.PRODUCT_CODE_ORD;
        productCode[BUSINESS_CONST.PRODUCT_TYPE_TC] = BUSINESS_CONST.PRODUCT_CODE_TCR;
        productCode[BUSINESS_CONST.PRODUCT_TYPE_REVOLVING] = BUSINESS_CONST.PRODUCT_CODE_CRP;
        productCode['default'] = '';

        bitacoraEventPre = `${bitacoraEventPre}_${productCode[product.product_type] ? productCode[product.product_type] : productCode['default']}`;
      } else {
        if (
          product.product_type == BUSINESS_CONST.PRODUCT_TYPE_FREE
        ) {
          this.bitacoraService.saveDataInBitacora(
            `${bitacoraEventPre}${gray_zone}_ord`,
          );
        }
        if (
          product.product_type == BUSINESS_CONST.PRODUCT_TYPE_LOAN
        ) {
          this.bitacoraService.saveDataInBitacora(
            `${bitacoraEventPre}${gray_zone}_lbza`,
          );
        }
        if (product.product_type == BUSINESS_CONST.PRODUCT_TYPE_TC) {
          this.bitacoraService.saveDataInBitacora(
            `${bitacoraEventPre}${gray_zone}_tc`,
          );
        }
        if (product.product_type == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING) {
          this.bitacoraService.saveDataInBitacora(
            `${bitacoraEventPre}${gray_zone}_rot`,
          );
        }
      }
    });

    if (this.firmlyApproved) {
      this.bitacoraService.saveDataInBitacora(bitacoraEventPre);
    }

    await this.callCreatePerform();
    // Terminates the process if the creation request fails.
    const nextStepSuccessful = !this.grayZone ? '200' : '201';
    if (
      (this.acctStatus as AccountCreationStatus) ===
      AccountCreationStatus.REQUEST_FAILED ||
      (this.acctStatus as AccountCreationStatus) ===
      AccountCreationStatus.NOT_REQUESTED
    ) {
      return;
    }
    // Waits for a while.
    this.bitacoraService.saveDataInBitacora('Ini_loading_Product');
    await this.abreCuentasService.sleep(
      this.parametersService.getSetting(OpEnum.BONDING_ASYNC)['sleep'],
    );

    const enrol = this.stringFormat.transform(this.endpointService.URLS.ENROLLMENT, [this.authService.getSessionId()]);
    this.captureService
      .getChannelComunicator(true)
      .then(async (res2: any) => {
        // this.loader.hide('Alta_Productos_zn');
        const goToEnrollment =
          this.parameterService.getParameter(OpEnum.GO_TO_ENROLLMENT)['active'][this.selectedProduct.product_type]
            ? this.parameterService.getParameter(OpEnum.GO_TO_ENROLLMENT)['active'][this.selectedProduct.product_type]
            : (this.parameterService.getParameter(OpEnum.GO_TO_ENROLLMENT)['pasive'][this.selectedProduct.product_type]
              ? this.parameterService.getParameter(OpEnum.GO_TO_ENROLLMENT)['pasive'][this.selectedProduct.product_type]
              : false);
        if (
          (this.channelCommunicatorService.getChannelId() === '141')
          && !this.abreCuentasService.getPostlogin()
          && goToEnrollment
        ) {
          console.warn('Go To ENROLLMENT: ', goToEnrollment, ' - url: ', enrol);
          this.channelCommunicatorService.getImpl().openPage(enrol, 5, false);
          this.loader.hide('Alta_Productos_zn');
        } else
          if ((CHANNEL.PORTALO.CODE ===
            this.channelCommunicatorService.getChannelId()) &&
            this.abreCuentasService.getflagGreyZone()
          ) {
            this.loader.hide('Alta_Productos_zn');
            this.bitacoraService.saveDataInBitacora('Out_loading_Product');
            this.navigationService.navigateToGeneralInformation('137');
            return;
          } else if (nextStepSuccessful === '200') {
            this.bitacoraService.saveDataInBitacora('Out_loading_Product');
            this.navigateValidateSaving(nextStepSuccessful);
            return;
          } else {
            res2 === '107' ||
              res2 === '121' ||
              res2 === '130' ||
              res2 === '129' ||
              res2 === '124' ||
              res2 === '125' ||
              res2 === '127'
              ? this.navigationService.navigateToGeneralInformation(res2)
              : this.navigationService.nextStep(res2);
          }
        if (
          res2 === '124' &&
          this.abreCuentasService.getPostlogin() === true &&
          !this.grayZone === true
        ) {
          this.navigationService.pageLoadTag('SolicitudEnProcesoTimeOut', [
            'pv456',
            '',
            '',
            '',
          ]);
        }
        if (res2 === '208') {
          this.bitacoraService.saveDataInBitacora('Possible_fraud_Yes');
        } else if (res2 === '20-04') {
          res2 = '208';
          this.bitacoraService.saveDataInBitacora('Possible_fraud_incident');
        }

        if (
          this.selectedProduct.product_type ===
          BUSINESS_CONST.PRODUCT_TYPE_TC &&
          res2 === '121'
        ) {
          const event = {
            eventToken: 'huswfn',
            callbackParams: callbackAdjustContratarTC,
          };
          this.adjustEvent.adjustTrackEvent(event);
        }
        this.bitacoraService.saveDataInBitacora('Out_loading_Product');
        this.productLoaderService.hide();
        this.loader.hide('Alta_Productos_zn');
      })
      .catch(() => {
        this.loader.hide('Alta_Productos_zn');
        this.navigationService.navigateToGeneralInformation('107');
      });
  }

  private navigateValidateSaving(nextStepSuccessful: string): void {
    this.loader.hide('Alta_Productos_zn');
    if (nextStepSuccessful === '200') {
      if (!this.firmlyApprovedServices.isEmpty()) {
        let product_list: any = [];
        product_list.push(this.abreCuentasService.getproductSelected());
        if (product_list[0] && product_list[0].product_code === 'MULTI') {
          const productsType = {
            freeInvestment: 'ORD',
            creditCard: 'TCR',
            revolvingCredit: 'CRP',
          };
          const products = this.firmlyApprovedServices.getDetailProductsMulti();
          const offerProducts: any = [];
          products.forEach((product: any) => {
            if (!offerProducts.some((offerType: string) => offerType === productsType[product.product_type])) {
              offerProducts.push(productsType[product.product_type]);
            }
          });
          product_list = [{
            product_code: String(offerProducts),
          }];
        }
        this.firmlyApprovedServices.turnOffOffer(
          OFFERS_STATUS_CONST.PRODUCT_ACCEPTED.CODE,
          product_list,
        );
      }
      if (this.selectedProduct.product_type !== BUSINESS_CONST.PRODUCT_TYPE_TC) {
        this.loader.hide('Alta_Productos_zn');
        this.navigationService.navigateToGeneralInformation('138');
        return;
      } else if (this.selectedProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC) {
        if (this.client) {
          let products_savings;
          if (this.abreCuentasService.getClientProduct()) {
            products_savings = this.abreCuentasService.getListClientProduct().filter((products: { product_type: string; }) => {
              return products.product_type === 'AHO';
            });
          } else {
            products_savings = [];
          }
          if (products_savings.length >= 1) {
            this.navigationService.navigateToGeneralInformation('138');
            return;
          } else {
            this.navigationService.navigateToGeneralInformation('136');
            return;
          }
        } else {
          this.navigationService.navigateToGeneralInformation('136');
          return;
        }
      }
      return;
    }
  }

  async callCreatePerform() {
    this.acctStatus = AccountCreationStatus.NOT_REQUESTED;
    this.signOnService.termsAndConditions();
    const body = {
      data: [
        {
          solicitation_completed: true,
          solicitation_type: 'tskAvanzarProcesoDigital',
        },
      ],
    };
    await this.signOnService
      .createCasePerformSolicitation(
        body,
        this.abreCuentasService.getSolicitationId(),
      )
      .then(async (res: any) => {
        try {
          this.acctProcessId = res.data.solicitation_id;
          this.acctStatus = AccountCreationStatus.REQUESTED;
        } catch (error) {
          this.acctStatus = AccountCreationStatus.REQUEST_FAILED;
          this.loader.hide('Alta_Productos_zn');
          this.navigationService.navigateToGeneralInformation('500');
          return;
        }
      })
      .catch(() => {
        this.acctStatus = AccountCreationStatus.REQUEST_FAILED;
        this.loader.hide('Alta_Productos_zn');
        this.navigationService.navigateToGeneralInformation('127');
        return;
      });
  }

  async checkBioCatch() {
    this.loader.show('Alta_Productos_zn');
    let gray_zone = '';
    const product_name = this.abreCuentasService.getproductSelected().product_code;
    if (
      this.selectedProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC &&
      this.abreCuentasService.isGrayZone()
    ) {
      gray_zone = 'zg_';
    }

    let bitacoraEvent = '';
    if (this.firmlyApproved && product_name !== 'MULTI') {
      const productType = {
        ORD: 'cp',
        TCR: 'tc',
        CRP: 'cr',
        default: '',
      };
      this.bitacoraService.saveDataInBitacora(`offer_approvedf_${product_name}`);
      bitacoraEvent = `af_accepted_multi_${productType[product_name] ? productType[product_name] : productType.default}`;
    } else {
      bitacoraEvent = `product_accepted_${gray_zone}${product_name}`;
    }
    this.bitacoraService.saveDataInBitacora(bitacoraEvent);
    // Relacionados
    if (product_name === 'TCR') {
      await this.checkRelated();
      /* if (!this.continueRelated) {
        this.productLoaderService.hide();
        return;
      } */
    }
    await this.bioCatchService.update();

    this.bioCatchService
      .checkScore(false)
      .then(
        response => {
          console.log('--------- Response Biocatch Score---------');
          console.log(response);
          if (response.data.response) {
            this.next();
            return;
          }
          this.productLoaderService.hide();
          this.navigationService.navigateToGeneralInformation('122');
          if (this.abreCuentasService.getPostlogin() === true) {
            this.navigationService.pageLoadTag('ErrorBiocatch', [
              '',
              '',
              'pv580',
              '',
            ]);
          } else {
            this.navigationService.pageLoadTag('ErrorCrearTuCuenta', [
              '',
              '',
              'pv582',
              '',
            ]);
          }
          this.productLoaderService.hide();
          this.navigationService.pageLoadTag('Error carga vinculacion', [
            '',
            'pv132',
            'pv93',
          ]);
        },
        () => {
          this.navigationService.navigateToGeneralInformation('500');
          this.productLoaderService.hide();
        },
      )
      .catch(() => {
        this.productLoaderService.hide();
        this.navigationService.navigateToGeneralInformation('500');
      });
  }

  async checkRelated() {
    this.continueRelated = true;
    let document = this.abreCuentasService.getDocumentInfo().document_number;
    const resInfo = await this.identificationService.validateIfIsRelated(
      document,
    );
    if (!resInfo.related) {
      return;
    }
    // BITÁCORA CON employee_members
    const bitacoraEvent = `employee_members`;
    this.bitacoraService.saveDataInBitacora(bitacoraEvent);

    // Verificar estado PCO
    let pcoStatus =
      this.abreCuentasService.getPcoModel().solicitation_status.status_code;

    // PCO Aprobado continúa a "Tu solicitud fue recibida y la estamos validando"
    if (pcoStatus !== 'PCO01') {
      return;
    }
    this.navigationService.nextStep('202');
    this.continueRelated = false;
  }

  /**
   * Opens link to itau page
   *
   *
   * @memberof DetailAccountCreationComponent
   */
  openLink() {
    this.channelCommunicatorService
      .getImpl()
      .openExternalBrowser(
        this.copyService.copies.detail_account_creation_link,
        5,
        true,
      );
  }

  showMore(product_type: any) {
    if (this.active == product_type) {
      this.active = '';
    } else {
      this.active = product_type;
    }
  }

  getValueObject(object: any, property: any) {
    if (object && object.hasOwnProperty(property)) {
      return object[property];
    } else {
      // tslint:disable-next-line:no-return-undefined
      return undefined;
    }
  }

  freeInvestmentDetail() {
    let transaction = this.transaction.filter(
      transactionFilter =>
        transactionFilter.account_type === '211' &&
        transactionFilter.segmentation_id === '315',
    );
    if (
      this.granted_product_multi.filter(
        fil => fil.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE,
      )
    ) {
      const rates = this.firmlyApproved
        ? this.abreCuentasService.getAbreCuentasModel().creditParms.rateValue
        : this.requestService.getRates();
      const rate = this.firmlyApproved
        ? `${rates.rate_EA}% EA  (${rates.rate_MV}% MV)`
        : `${rates[0].value}% ${rates[0].type}  (${rates[1].value}% ${rates[1].type})`;
      this.dataProducts.push({
        product_type: BUSINESS_CONST.PRODUCT_TYPE_FREE,
        rate,
        transactionkit: this.copyService.getCopy(
          'detail_account_creation_free_investment',
        ),
        maxPeriodValue:
          this.abreCuentasService.getAbreCuentasModel().creditParms
            .maxPeriodValue,
        es: BUSINESS_CONST.FREE_INVESTMENT,
      });
    }
  }

  monthly(months: number) {
    return `${months} ${this.copyService.copies.account_info_creation.monthly}`;
  }

  isGranted(product_type: string) {
    const productsGranted = this.abreCuentasService.getPcoModel().granted_product_multi;
    const granteds = productsGranted.filter(i => i.product_type === product_type);
    return granteds.length > 0;
  }

  loanDetail() {
    if (
      this.granted_product_multi.filter(
        fil => fil.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN,
      )
    ) {
      this.disbursment = this.abreCuentasService.getDisbursementInfo();
      let refund: any;
      if (this.disbursment && this.disbursment.length > 0) {
        refund = this.disbursment[0].refund;
      }
      if (refund && refund[0] && refund[0].refund_method !== 'CH') {
        this.accountNumber = refund[0].account ? this.validationHelperService.maskPhone(refund[0].account.account_id) : '';
      }
      this.isCreateSavingsLoan = this.accountNumber === '';
      this.check = this.abreCuentasService.getOutlaySelection() === 'cheque';
      const creditParamsLib =
        this.abreCuentasService.getAbreCuentasModel().creditParms;
      this.dataProducts.push({
        product_type: BUSINESS_CONST.PRODUCT_TYPE_LOAN,
        amount: this.numberHelper.pcoFormat(creditParamsLib.maxAmountValue),
        rate: this.abreCuentasService.getRatesLoan(),
        transactionkit: '',
        maxPeriodValue: creditParamsLib.maxPeriodValue,
      });
    }
  }

  setAccounterNumber(refund: any): void {
    if (refund && refund[0] && refund[0].refund_method !== 'CH') {
      this.accountNumber = refund[0].account
        ? this.validationHelperService.maskPhone(refund[0].account.account_id)
        : '';
    }
  }

  creditCardDetail() {
    const card = this.iscardDuality
      ? this.abreCuentasService.getCardTypesModel()
      : this.abreCuentasService.getCardTypeModel();
    const transaction = this.transaction.filter(
      transactionFilter =>
        transactionFilter.account_type === '219' &&
        transactionFilter.segmentation_id ===
        this.abreCuentasService.getSegmentID(),
    );
    if (!this.iscardDuality) {
      this.cardType = {
        ...card,
        periodo_exoneracion: card.periodo_exoneracion
          ? card.periodo_exoneracion.toLowerCase().replace(' ', ' primeros ')
          : '',
        couta_manejo: card.couta_manejo
          ? card.couta_manejo.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
          : '',
        meta_facturacion_mensual: card.meta_facturacion_mensual
          ? card.meta_facturacion_mensual.replace(
            /(\d)(?=(\d{3})+(?!\d))/g,
            '$1.',
          )
          : '',
      };
      transaction[0].detail[0].value =
        this.cardType.tipo_tarjeta.replace('Ã¡', '\u00E1') +
        ' ' +
        this.abreCuentasService.getPayDayProductSelected().selectedProduct
          .label;
      transaction[0].detail[3].value =
        this.abreCuentasService.getPayDayProductSelected().selectedPayDay.label;

      if (this.grayZone) {
        transaction[0].detail[0].detail = 'Franquicia';
        transaction[0].detail = transaction[0].detail.filter(
          filter =>
            filter.tag_name === 'typeCard' || filter.tag_name === 'payDay',
        );
      }

      if (
        this.granted_product_multi.filter(
          fil => fil.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC,
        )
      ) {
        this.dataProducts.push({
          product_type: BUSINESS_CONST.PRODUCT_TYPE_TC,
          cardType: this.cardType,
          transactionkit: transaction[0],
          es: BUSINESS_CONST.CREDIT_CARD,
        });
      }
    } else {
      const virtualCard =
        this.abreCuentasService.getVirtualCardFranchise().selectedFranchise;
      const cardvector: any = Object.values(card);
      cardvector.forEach(target => {
        target.periodo_exoneracion =
          target && target.periodo_exoneracion
            ? target.periodo_exoneracion
              .toLowerCase()
              .replace(' ', ' primeros ')
            : '';
        target.couta_manejo = target.couta_manejo
          ? target.couta_manejo.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
          : '';
        target.detailDual = transaction[0].detailDual.slice();
        target.virtualCard = target.brand === virtualCard.label;
        target.payDay =
          this.abreCuentasService.getPayDayProductSelected().selectedPayDay.label;
      });
      cardvector.map(outVirtual => {
        if (!outVirtual.virtualCard) {
          outVirtual.detailDual.splice(1, 1);
        }
      });
      this.dataProducts.push({
        product_type: BUSINESS_CONST.PRODUCT_TYPE_TC,
        cardTypes: cardvector,
        transactionkit: transaction[0],
        iscardDuality: this.iscardDuality,
        es: BUSINESS_CONST.CREDIT_CARD,
      });
    }
  }

  revolvingDetail() {
    if (
      this.granted_product_multi.filter(
        fil => fil.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING,
      )
    ) {
      if (this.abreCuentasService.getAssociateRevolving()) {
        this.accountNumberRevolving = this.validationHelperService.maskPhone(this.abreCuentasService.getAssociateRevolving().account_id);
      }
      let transaction = this.transaction.filter(
        transactionFilter =>
          transactionFilter.account_type ===
          this.infoInferredIncomes.account_type &&
          transactionFilter.segmentation_id ===
          this.abreCuentasService.getSegmentID(),
      );
      this.dataProducts.push({
        product_type: BUSINESS_CONST.PRODUCT_TYPE_REVOLVING,
        es: this.copyService.copies.gray_zone_type_revolving.productName,
        transactionkit: [],
      });
    }
  }

  savingAccountDetail() {
    if (!this.abreCuentasService.getcreateProductSelected() && !this.isRevolingCreateSavings) {
      this.createAccountSaving();
    }
  }

  savingAccountDetailRevolving() {
    if (!this.abreCuentasService.getAssociateRevolving() && !this.isCreateSavingsLoan) {
      this.isRevolingCreateSavings = true;
      this.createAccountSaving();
    }
  }

  createAccountSaving() {
    const transaction = this.transaction.filter(
      transactionFilter =>
        transactionFilter.account_type ===
        this.infoInferredIncomes.account_type &&
        transactionFilter.segmentation_id ===
        this.abreCuentasService.getSegmentID(),
    );
    this.dataProducts.push({
      product_type: BUSINESS_CONST.PRODUCT_TYPE_SAVINGS,
      transactionkit: transaction[0],
      es: 'Cuenta de ahorros',
    });
  }

  goToLink() {
    this.channelCommunicatorService
      .getImpl()
      .openExternalBrowser('https://www.itau.co/tasasytarifas', 5, true);
  }
  getCopiesByCase() {
    this.productsSelectedMulti.forEach(products => {
      if (products.product_type === 'loan') {
        this.isLoan = true;
        this.isBtnDisabled = false;
        if (
          this.selectedOccupation === 'Empleado' &&
          this.requestLoan === '01'
        ) {
          this.copiesDocToSend = [
            {
              desc: this.documentation_to_send.documentsLibEmployee
                .proofPayment,
            },
            {
              desc: this.documentation_to_send.documentsLibEmployee
                .workingLetter,
            },
            {
              desc: this.documentation_to_send.documentsLibEmployee
                .salaryCertificate,
            },
          ];
        } else if (
          this.selectedOccupation === 'Empleado' &&
          this.requestLoan === '02'
        ) {
          this.copiesDocToSend = [
            {
              desc: this.documentation_to_send.documentsLibEmployeeWithCart
                .proofPayment,
            },
            {
              desc: this.documentation_to_send.documentsLibEmployeeWithCart
                .workingLetter,
            },
            {
              desc: this.documentation_to_send.documentsLibEmployeeWithCart
                .debtCertificateBank,
            },
            {
              desc: this.documentation_to_send.documentsLibEmployeeWithCart
                .salaryCertificate,
            },
          ];
        } else if (
          this.selectedOccupation === 'Pensionado' &&
          this.requestLoan === '01'
        ) {
          this.copiesDocToSend = [
            {
              desc: this.documentation_to_send.documentsLibPensioner
                .proofPayment,
            },
            {
              desc: this.documentation_to_send.documentsLibPensioner
                .debtStatement,
            },
            {
              desc: this.documentation_to_send.documentsLibPensioner
                .salaryCertificate,
            },
            {
              desc: this.documentation_to_send.documentsLibPensioner
                .bankStatements,
            },
          ];
        } else if (
          this.selectedOccupation === 'Pensionado' &&
          this.requestLoan === '02'
        ) {
          this.copiesDocToSend = [
            {
              desc: this.documentation_to_send.documentsLibPensionerWithCart
                .proofPayment,
            },
            {
              desc: this.documentation_to_send.documentsLibPensionerWithCart
                .debtCertificateBank,
            },
            {
              desc: this.documentation_to_send.documentsLibPensionerWithCart
                .debtStatement,
            },
            {
              desc: this.documentation_to_send.documentsLibPensionerWithCart
                .salaryCertificate,
            },
            {
              desc: this.documentation_to_send.documentsLibPensionerWithCart
                .bankStatements,
            },
          ];
        }
      }
    });
  }
  setSubTitle() {
    this.subTitle = this.isLoan
      ? this.documentation_to_send.textDescription
      : this.copyService.getParametrizedCopy(this.copiesProperty['mainLabel'], [
        this.documentInfo.firstname,
      ]);
  }
  setBTNNex() {
    this.labelBTN = this.isLoan
      ? this.documentation_to_send.next
      : this.documentation_to_send.request;
  }
  async restrictiveList() {
    const restrictive_params = this.parametersService.getSetting(OpEnum.RESTRICTIVE_PARAMETERS);
    const data_user = this.abreCuentasService.getDocumentInfo();
    const fullName = `${data_user.firstname} ${data_user.middlename} ${data_user.primary_lastname} ${data_user.second_lastname}`;
    const body = {
      data: {
        client_name: fullName,
        document: {
          number: data_user.document_number,
        },
        user_name: restrictive_params.user_name,
        employee_id: restrictive_params.employee_id,
        application: restrictive_params.application,
        priority: restrictive_params.priority,
        reference_type: restrictive_params.reference_type,
        transaction_type: restrictive_params.transaction_type,
      },
    };
    await this.requestService.getRestrictiveList(body).then(async (res: any) => {
      const data: any = {
        list_query_status: {
          status_code: res.data.status_code,
        },
        client: this.abreCuentasService.getProspectResponse().client,
      };
      this.abreCuentasService.setProspectResponse(data);
      if (res.data.status_code === '5') {
        this.navigationService.navigateToGeneralInformation('107');
        return;
      }
    }).catch(() => this.navigationService.navigateToGeneralInformation('107'));
  }

  /* ------------- Taggeo ------------- */

  /* ------------ Taggeo - PageLoad ------------ */
  sendDetailCreationPageLoad(): void {
    const isApp = this.channelCommunicatorService.getChannelId() === '141';
    const changes: IPageLoadModel[] = [
      {
        path: PAGEVIEW_FA.pv13pageName.path,
        value: `${isApp ? CHANNEL_FA.superapp : CHANNEL_FA.homeBanking}:${COUNTRY_FA.co}:${BUSINNESS_FA.pf}:${ENVIRONMENT_FA.loggeado}:${FAMILY_FA.services}:${SUBFAMILY_FA.request}:${PRODUCT_FA.request}:${PAGEVIEW_FA.pv13pageName.value}`,
      },
      {
        path: PAGEVIEW_FA.pv13pageFamily.path,
        value: PAGEVIEW_FA.pv13pageFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv13subFamily.path,
        value: PAGEVIEW_FA.pv13subFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv13pageAction.path,
        value: PAGEVIEW_FA.pv13pageAction.value,
      },
      {
        path: PAGEVIEW_FA.pv13pageid.path,
        value: DetailAccountCreationComponent.name,
      },
      {
        path: PAGEVIEW_FA.pv13transactionName.path,
        value: `${PAGEVIEW_FA.pv13transactionName.value.slice(0, -2)}${this.taggingServices.getProductFlow()}`,
      },
      {
        path: PAGEVIEW_FA.pv13transactionTransactionStep.path,
        value: PAGEVIEW_FA.pv13transactionTransactionStep.value,
      },
    ];
    this.taggingServices.addCommonPageChanges(changes);
    this.daliService.pageLoad(changes);
  }

  /* -------------- Taggeo - Events ------------- */
 /*  sendBackButtonEvent(): void {
    if (this.taggingServices.isFirmlyAprovedMono()) {
      return;
    }
    const data = [
      {
        path: EVENT_FA_TC.pv13E1setData.pv13E1transactionTransactionStep.path,
        value: EVENT_FA_TC.pv13E1setData.pv13E1transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_TC.pv13E1setData.pv13E1transactionName.path,
        value: EVENT_FA_TC.pv13E1setData.pv13E1transactionName.value, // cambiar valor segun sea LD o TC
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_TC.customCategory.module.body,
        type: EVENT_FA_TC.customCategory.type.button,
        position: EVENT_FA_TC.customCategory.position.center,
      },
      action: EVENT_FA_TC.customAction.click,
      label: EVENT_FA_TC.pv13E1customLabel,
    };
    this.daliService.trackEvent(event, data);
  } */

  sendContinueButtonEvent(): void {
    const data = [
      {
        path: EVENT_FA_TC.pv13E2setData.pv13E2transactionTransactionStep.path,
        value: EVENT_FA_TC.pv13E2setData.pv13E2transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_TC.pv13E2setData.pv13E2transactionName.path,
        value: EVENT_FA_TC.pv13E2setData.pv13E2transactionName.value, // cambiar valor segun sea LD o TC
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_TC.customCategory.module.body,
        type: EVENT_FA_TC.customCategory.type.button,
        position: EVENT_FA_TC.customCategory.position.center,
      },
      action: EVENT_FA_TC.customAction.click,
      label: EVENT_FA_TC.pv13E2customLabel,
    };
    this.daliService.trackEvent(event, data);
  }

  /* showBackButton() {
    if (this.selectedProduct.product_type == BUSINESS_CONST.PRODUCT_TYPE_SAVINGS
      || this.selectedProduct.product_type == BUSINESS_CONST.PRODUCT_TYPE_PAYROLL) {
      this.showBackBtn = true;
    } else {
      this.showBackBtn = false;
    }
  } */
}
